export const EPIC_LINK_MAX_RESULTS = 20;
